module.exports = __webpack_public_path__ + "img/fed9e4b.png";